import { Redirect, Route, Switch } from "react-router-dom";

import Sidebar from "../components/Sidebar";

import AdminDashboard from "../pages/Admin/Dashboard";
import AdminChecklistAn from "../pages/Admin/ChecklistAn";
import AdminChecklistDo from "../pages/Admin/ChecklistDo";
import Analise from "../pages/Admin/Analise";
import GerenciamentoPro from "../pages/Admin/GerenciamentoPro";
import ChecklistCo from "../pages/Admin/ChecklistCo";
import GerenciamentoCad from "../pages/Admin/GerenciamentoCad";
import Processo from "../pages/Admin/Processo";
import UserDetail from "../components/userDetails";

function AdmRoutes() {
  return (
    <Switch>
      <Route path="/dashboard" exact>
        <Sidebar />
        <AdminDashboard />
      </Route>
      <Route path="/checklist-an" exact>
        <Sidebar />
        <AdminChecklistAn />
      </Route>
      <Route path="/checklist-do" exact>
        <Sidebar />
        <AdminChecklistDo />
      </Route>
      <Route path="/analise" exact>
        <Sidebar />
        <Analise />
      </Route>
      <Route path="/gerenciamento-de-processos" exact>
        <Sidebar />
        <GerenciamentoPro />
      </Route>
      <Route path="/checklist-corretor" exact>
        <Sidebar />
        <ChecklistCo />
      </Route>
      <Route path="/gerenciamento-de-cadastros" exact>
        <Sidebar />
        <GerenciamentoCad />
      </Route>
      <Route path="/gerenciamento-de-cadastro/user&id=:id" exact>
        <Sidebar />
        <UserDetail />
      </Route>
      <Route path="/processo/id=:id" exact>
        <Sidebar />
        <Processo />
      </Route>
      <Redirect to="/dashboard" />
    </Switch>
  );
}

export default AdmRoutes;
